import styled from 'styled-components'

const ResponsiveSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0;
  margin: 20px auto;
  max-width: ${props => props.theme.metrics.contentMaxWidth}px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    margin: 60px auto;
    flex-direction: row;
  }
`
const TextContainer = styled.div`
  flex: 1;
  padding: 10px;
  width: 100%;
  border-radius: 12px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding: 20px;
    width: 50%;
  }
`

const H4 = styled.h4`
  font-weight: 800;
  font-size: 3em;
  margin: 10px 20px;
`

const H5 = styled.h5`
  font-weight: 500;
  font-size: 1.6em;
  margin: 20px 40px;
`

const BodyText = styled.p`
  font-size: 1.2em;
  line-height: 1.6em;
  margin: 20px 40px;
`

const RuleContainer = styled.div`
  flex: 1;
  padding: 10px;
  width: 100%;
  background-color: #efefef;
  border-radius: 12px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding: 20px;
    width: 50%;
  }
`

const RulesText = styled.p`
  font-size: 1.2em;
  line-height: 1.4em;
  margin: 20px 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid #b3b3b3;
`

const Disclaimer = styled.p`
  font-size: 0.8em;
  margin: 20px 40px;
`

const RulesRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    flex-direction: row;
  }
`

const CommissionRulesSection = () => (
  <>
    <ResponsiveSection>
      <TextContainer>
        <H4>New NAR Commission Rules</H4>
      </TextContainer>
      <TextContainer>
        <BodyText>
          On October 31st 2023, the National Association of Realtors and many big brokerages were
          found guilty of price fixing and collusion. Since that ruling, new regulations went into
          effect on August 17th 2024. As a buyer, there are two key changes you need to be aware of:
        </BodyText>
      </TextContainer>
    </ResponsiveSection>
    <ResponsiveSection>
      <RulesRow>
        <RuleContainer>
          <H5>Buyer Agency Agreement</H5>
          <RulesText>
            Before you start touring homes with a buyer agent, you’ll need to sign a Buyer Agency
            Agreement.
          </RulesText>
          <RulesText>
            This agreement will outline your relationship with your buyer agent. As a buyer, make
            sure this agreement is straightforward and transparent.
          </RulesText>
          <RulesText>
            Our partner agents have already agreed to share a portion of their commission if you buy
            through them.
          </RulesText>
          <Disclaimer>
            *You can cancel the agreement up until you go under contract on your new home.
          </Disclaimer>
        </RuleContainer>
        <RuleContainer>
          <H5>Buyer Agent Compensation</H5>
          <RulesText>Buyers now have a say in how their agents are compensated.</RulesText>
          <RulesText>
            Previously, buyer agents were typically paid by sharing the listing agent’s commission,
            which was not usually discussed with the buyer.
          </RulesText>
          <RulesText>
            Commissions can still be shared between agents, but now you, the buyer, must first agree
            to the terms. Alternatively, your buyer agent can be paid directly by the seller, or
            through a concession given to you by the seller, or directly from your pocket.
          </RulesText>
        </RuleContainer>
      </RulesRow>
    </ResponsiveSection>
  </>
)

export default CommissionRulesSection
